export default "__VITE_ASSET__Dn9Z971q__"